import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class AppFeedComponents extends BaseOption {
  static userInterfaceComponent = {
    label: "Component(s)",
    component: inspectorTools.APP_FEED_COMPONENT_PICKER,
    props: {},
  };

  static defaultValue = null;
}
